import React from "react"
import styled from "styled-components"
import Wrapper from "../grid/wrapper"
import Row from "../grid/row"
import Column from "../grid/column"
import colors from "../../styles/colors"
import ScrollAnimation from "react-animate-on-scroll"
import Phone from "../../images/phone.svg"
import Email from "../../images/email_icon.svg"
import Whatsapp from "../../images/whatsapp_icon.svg"
import fonts from "../../fonts"
import breakpoints from '../../styles/breakpoints'

const Anchor = styled.div`
  display: block;
  position: relative;
  top: -60px;
  visibility: hidden;
`

const ContactContainer = styled.div`

`
const ContactHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`

const ContactTitle = styled.div`
  font-size: 48px;
  line-height: 50px;
  font-family: ${fonts.roca};
  font-weight: bold;
  text-align: center;
  margin: 0 auto 0;

  @media ${breakpoints.tablet}{
    margin: 0 auto 40px;
  }
`

const ContactSubtitle = styled.div`
  p{
    font-family: ${fonts.helvetica};
    font-size: 16px;
    line-height: 24px;
    text-align: center;
  }
`

const ContactTelf = styled.a`
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: ${colors.tertiaryDark};
  transition: all 0.4s ease;
  opacity: 1;
  text-decoration:none;
  margin-bottom: 20px;
  :hover {
    opacity: 0.6;
  }
`

const ContactEmail = styled.a`
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: ${colors.tertiaryDark};
  transition: all 0.4s ease;
  opacity: 1;
  text-decoration:none;
  margin-bottom: 20px;
  :hover {
    opacity: 0.6;
  }
`

const ContactWhatsapp = styled.a`
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: ${colors.tertiaryDark};
  transition: all 0.4s ease;
  opacity: 1;
  text-decoration:none;
  margin-bottom: 20px;
  :hover {
    opacity: 0.6;
  }
`

const Icon = styled.img`
  width: 24px;
  margin-right: 10px;
`

const ContactBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  margin-bottom: 40px;

  @media ${breakpoints.tablet}{
    margin-bottom: 100px;
  }
  
`

const Contact = () => {
  return (
    <section>
      <Anchor id="after-sales" />
      <Wrapper>
        <ContactContainer>
          <Row>
            <Column xs={10} align="center">
              <ContactHeader>
                <ContactTitle>
                  <ScrollAnimation animateIn="fadeIn">
                    After Sales Service
                  </ScrollAnimation>
                </ContactTitle>
                <ContactSubtitle>
                  <ScrollAnimation animateIn="fadeIn">
                    <p>Roca Indonesia menyediakan tim profesional dan ahli untuk memberikan layanan kepada pelanggan seperti saran teknis, demonstrasi produk, pra-instalasi produk, instalasi produk, dan perbaikan produk garansi & non-garansi. Roca juga menyediakan agen profesional yang responsif untuk menanggapi pertanyaan, permintaan, dan keluhan dari pelanggan, serta menyediakan pelatih profesional dan ahli untuk memberikan pelatihan mengenai produk dan solusi teknis Roca kepada pelanggan. Selain itu after sales service Roca juga menyediakan penjualan suku cadang asli kepada pelanggan.</p>
                    <p>Customer service Roca Indonesia selalu siap untuk membantu ada, hubungi call center kami:</p>
                  </ScrollAnimation>
                </ContactSubtitle>
                <ContactBox>
                  <ContactTelf href="tel:1500042">
                    <Icon alt="phone-icon" src={Phone} /> 1500042
                  </ContactTelf>
                  <ContactEmail href="mailto:callcenterid@id.roca.com">
                    <Icon alt="email-icon" src={Email} /> callcenterid@id.roca.com
                  </ContactEmail>
                  <ContactWhatsapp href="tel:+628118470042">
                    <Icon alt="whatsapp-icon" src={Whatsapp} /> +628 118 470 042
                  </ContactWhatsapp>
                </ContactBox>
              </ContactHeader>
            </Column>
          </Row>
        </ContactContainer>
      </Wrapper>
    </section>
  )
}
export default Contact